// extracted by mini-css-extract-plugin
export var brand = "_8d-9";
export var compact = "_8d-6";
export var extraSmall = "_8d-7";
export var icon = "_8d-0";
export var large = "_8d-4";
export var light = "_8d-1";
export var medium = "_8d-5";
export var outline = "_8d-b";
export var primaryDark = "_8d-a";
export var primaryLight = "_8d-8";
export var primaryModern = "_8d-c";
export var success = "_8d-2";
export var successSolid = "_8d-3";